export const uiBreadcrumbsWithExpandHandler = () => {
  const breadcrumbsSelector = $(
    ".ui-breadcrumbs--with-expand .ui-breadcrumbs__item"
  );
  const breadcrumbsBtnSelector = $(".js-breadcrumbs__button");

  if (breadcrumbsSelector.length > 2) {
    breadcrumbsSelector.parent().addClass("with-expand");
  }

  if (breadcrumbsBtnSelector) {
    breadcrumbsBtnSelector.click(function() {
      breadcrumbsSelector.parent().removeClass("with-expand");
    });
  }
};
